<template>
  <div class="container">
    <top-bar class="top-bar"></top-bar>
    <div class="feedback" @click="onOpenFeedbackDialogClick"><div class="feedback-img"></div></div>
    <div class="page-container">
      <router-view class="page-content"></router-view>
    </div>
    <Footer></Footer>

    <el-dialog
      title="提交问题"
      class="dialog"
      :visible.sync="dialogVisible"
      width="400px"
      >
      <div class="content">
        <div class="dialog-title">问题标题<span class="asterisk">*</span></div>
        <el-input clearable class="dialog-input" placeholder="输入问题名称标题" v-model="questionTitle"></el-input>
        <div class="dialog-title">问题描述<span class="asterisk">*</span></div>
        <el-input type="textarea" class="dialog-input" placeholder="简单描述一下问题" v-model="questionDescribe"></el-input>
        <div class="dialog-title">您的手机号<span class="asterisk">*</span></div>
        <el-input clearable class="dialog-input" placeholder="输入您的手机号码" v-model="telNumber"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="cancel-btn" @click="cancelBtnClick">取消</el-button>
        <el-button class="confirm-btn" @click="confirmBtnClick">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import TopBar from '@/components/common/TopBar';
import Footer from '@/components/common/Footer';
import QuestionQuery from '@/rest/questionQuery';

export default {
  data() {
    return {
      dialogVisible: false,
      questionTitle: '',
      telNumber: '',
      questionDescribe: ''
    };
  },
  components: {
    TopBar,
    Footer
  },
  methods: {
    onOpenFeedbackDialogClick() {
      this.dialogVisible = true;
    },
    cancelBtnClick() {
      this.dialogVisible = false;
      this.questionTitle = '';
      this.questionDescribe = '';
      this.telNumber = '';
    },
    confirmBtnClick() {
      if (!this.questionTitle) {
        this.$message({
          message: '请输入问题标题',
          duration: 1500,
          type: 'error'
        });
      } else if (!this.questionDescribe) {
        this.$message({
          message: '请输入问题描述',
          duration: 1500,
          type: 'error'
        });
      } else if (!this.telNumber) {
        this.$message({
          message: '请输入手机号',
          duration: 1500,
          type: 'error'
        });
      } else if (!/^1[3456789]\d{9}$/.test(this.telNumber)) {
        this.$message({
          message: '手机号不正确',
          duration: 1500,
          type: 'error'
        });
      } else {
        QuestionQuery.feedbackPropose(this.questionTitle, this.questionDescribe, this.telNumber).then(() => {
          this.$message({
            message: '感谢您的反馈',
            duration: 2000,
            type: 'success'
          });
          this.cancelBtnClick();
          if (this.$router.currentRoute.path === '/feedback') {
            eventBus.$emit('getFeedbackList');
          }
        },
        (err) => {
          this.$message({
            message: err.response.data.message,
            duration: 2000,
            type: 'error'
          });
        });
      }
    }
  },
  mounted() {
    eventBus.$on('newFeedback', () => {
      this.dialogVisible = true;
    });
  }
};
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  height:100%;
  background-color: #f7f7fa;
  box-shadow: inset 0px -1px 0px 0px #f2f3f7;
  .feedback {
    position: fixed;
    right: 40px;
    bottom:72px;
    width: 40px;
    height: 40px;
    border-radius: 2px;
    background-color: #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(9, 4, 69, 0.1);
    z-index: 1;
    cursor: pointer;
    .feedback-img {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 18px;
      height: 18px;
      background-image: url("../assets/img/feedback.svg");
      background-size: cover;
    }
  }
  .page-container {
    padding-top: 48px;
  }            
}

/deep/.dialog {
    .content {
      .dialog-title {
        margin-bottom: 4px;
        color: rgba(104, 107, 133, 1);
        font-weight: 500;
        font-size: 14px;
        .asterisk {
          color: #eb697c;
        }
      }
      .dialog-input {
        margin-bottom: 17px;
      }
      .dialog-input:last-child {
        margin-bottom: 0;
      }
    }
    .el-dialog {
      height: 473px;
      box-shadow: 0px 8px 20px 0px rgba(0, 22, 144, 0.14);
      border-radius: 2px;
      .el-dialog__header {
        // padding: 0;
        padding: 16px 0 16px 24px;
        .el-dialog__title {
          color: rgba(62, 64, 78, 1);
          font-size: 18px;
          font-weight: 500;
        }
      }
      .el-dialog__body {
        padding: 8px 24px 24px;
        height: 361px;
        overflow: auto;
      }
      .el-dialog__footer {
        padding:0 24px 24px;
      }
    }
  }
  /deep/.el-input .el-input__inner {
      height: 40px;
      line-height: 40px;
      border-radius: 2px;
      border: solid 1px #e5e6ee;
      font-weight: 500;
      &::-webkit-input-placeholder {
        color: #d1d2da;
        font-weight:400 !important;
      }
      &::-moz-placeholder {
        color: #d1d2da;
        font-weight:400 !important;
      }
      &::-ms-input-placeholder {
        color: #d1d2da;
        font-weight:400 !important;
      }
      &:hover {
        border-radius: 2px;
        border: solid 1px #999ebe;
      }
      &:focus {
        border-radius: 2px;
        border: solid 1px #171f46;
      }
    }
    /deep/.el-textarea .el-textarea__inner {
      height: 143px;
      border-radius: 2px;
      border: solid 1px #e5e6ee;
      font-weight: 500;
      &::-webkit-input-placeholder {
        color: #d1d2da;
        font-weight:400 !important;
      }
      &::-moz-placeholder {
        color: #d1d2da;
        font-weight:400 !important;
      }
      &::-ms-input-placeholder {
        color: #d1d2da;
        font-weight:400 !important;
      }
      &:hover {
        border-radius: 2px;
        border: solid 1px #999ebe;
      }
      &:focus {
        border-radius: 2px;
        border: solid 1px #171f46;
      }
    }
    .cancel-btn {
      height: 32px;
      width: 60px;
      padding: 0;
      font-size: 14px;
      color: #171f46;
      background-color: rgba(0, 11, 92, 0.03);
      border-radius: 2px;
      border: none;
      &:hover {
        color: #171f46;
        background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
        background-blend-mode: normal, normal;
      }
      &:focus {
        color: #171f46;
        background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
        background-blend-mode: normal, normal;
      }
      &:active {
        color: #171f46;
        background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
        background-blend-mode: normal, normal;
      }
    }
    .confirm-btn {
      height: 32px;
      width: 60px;
      padding: 0;
      font-size: 14px;
      color: #ffffff;
      background-color: #0055ff;
      border-radius: 2px;
      border: none;
      &:hover {
        color: #ffffff;
        background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(#0055ff, #0055ff);
        background-blend-mode: normal, normal;
      }
      &:focus {
        color: #ffffff;
        background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(#0055ff, #0055ff);
        background-blend-mode: normal, normal;
      }
      &:active {
        color: #ffffff;
        background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(#0055ff, #0055ff);
        background-blend-mode: normal, normal;
      }
    }
</style>
